import React, { useState } from "react";
import { useClient } from "../../Context/ClientContext";
import { Tabs, Row, Card } from "antd";
import { RegisterDetail } from "./RegisterDetail";
import { useUser } from "../../../Context/UserContext";
import { findUserPremission } from "../Users/UserSecurityFind";
import { SettingsSections } from "../../Services/SettingService";
import { IPermissionActionType } from "../Users/UserPermissionCommonData";
import { ITypeIIsClientSpecificRoleDataType } from "../../../Context/RoleContext";

export const Registers = () => {
  const { currentClient } = useClient();
  const { clientSpecificRole } = useUser();
  const [activeTabKey, setActiveTabKey] = useState<string>("0");

  type TabItem = {
    label: string;
    key: string;
    children: React.ReactNode;
  };

  const items: TabItem[] = [
    {
      label: "Day Register",
      key: "0",
      children: (
        <>
          <RegisterDetail voucherType={0} />
        </>
      ),
    },
    ...(findUserPremission(
      [
        "Voucher.Sales.Invoice.View",
        "Voucher.Sales.ProformaInvoice.View",
        "Voucher.Sales.CreditNote.View",
        "Voucher.Sales.Receipt.View",
        "Voucher.Sales.Estimate.View",
        "Voucher.Sales.SalesOrder.View",

        "Voucher.Purchase.Bill.View",
        "Voucher.Purchase.DebitNote.View",
        "Voucher.Purchase.PaymentOut.View",
        "Voucher.Purchase.PurchaseOrder.View",

        "Voucher.Expenses.View",
        "Voucher.Income.View",

        "Voucher.Journal.View",

        "Voucher.Contra.View",

        "Voucher.Asset.FixedAsset.View",
      ],
      clientSpecificRole(),
      currentClient?.id!,
      [
        SettingsSections.Invoice,
        SettingsSections.PInvoice,
        SettingsSections.CrNote,
        SettingsSections.Receipt,
        SettingsSections.Quotation,
        SettingsSections.SOrder,

        // Purchase
        SettingsSections.PurInvoice,
        SettingsSections.DrNote,
        SettingsSections.Payment,
        SettingsSections.POrder,

        // expenses & income
        SettingsSections.Expenses,
        SettingsSections.Income,

        // Journal
        SettingsSections.Journal,
        // Contra
        SettingsSections.Contra,
        // Asset
        SettingsSections.Asset,
      ],
      {
        actionType: IPermissionActionType.View,
        dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
      }
    )
      ? [
          {
            label: "Sales Register",
            key: "1",
            children: (
              <>
                <RegisterDetail voucherType={1} />
              </>
            ),
          },
        ]
      : []),

    ...(findUserPremission(
      ["Voucher.Sales.CreditNote.View"],
      clientSpecificRole(),
      currentClient?.id!,
      [SettingsSections.CrNote],
      {
        actionType: IPermissionActionType.View,
        dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
      }
    )
      ? [
          {
            label: "Credit Note Register",
            key: "2",
            children: (
              <>
                <RegisterDetail voucherType={2} />
              </>
            ),
          },
        ]
      : []),

    ...(findUserPremission(
      ["Voucher.Sales.Receipt.View"],
      clientSpecificRole(),
      currentClient?.id!,
      [SettingsSections.Receipt],
      {
        actionType: IPermissionActionType.View,
        dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
      }
    )
      ? [
          {
            label: "Receipt Register",
            key: "6",
            children: (
              <>
                <RegisterDetail voucherType={6} />
              </>
            ),
          },
        ]
      : []),

    ...(findUserPremission(
      ["Voucher.Purchase.Bill.View"],
      clientSpecificRole(),
      currentClient?.id!,
      [SettingsSections.PurInvoice],
      {
        actionType: IPermissionActionType.View,
        dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
      }
    )
      ? [
          {
            label: "Purchase Register",
            key: "3",
            children: (
              <>
                <RegisterDetail voucherType={3} />
              </>
            ),
          },
        ]
      : []),

    ...(findUserPremission(
      ["Voucher.Purchase.DebitNote.View"],
      clientSpecificRole(),
      currentClient?.id!,
      [SettingsSections.DrNote],
      {
        actionType: IPermissionActionType.View,
        dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
      }
    )
      ? [
          {
            label: "Debit Note Register",
            key: "4",
            children: (
              <>
                <RegisterDetail voucherType={4} />
              </>
            ),
          },
        ]
      : []),

    ...(findUserPremission(
      ["Voucher.Purchase.PaymentOut.View"],
      clientSpecificRole(),
      currentClient?.id!,
      [SettingsSections.Payment],
      {
        actionType: IPermissionActionType.View,
        dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
      }
    )
      ? [
          {
            label: "Payment Register",
            key: "5",
            children: (
              <>
                <RegisterDetail voucherType={5} />
              </>
            ),
          },
        ]
      : []),

    ...(findUserPremission(
      ["Voucher.Expenses.View"],
      clientSpecificRole(),
      currentClient?.id!,

      [SettingsSections.Expenses],
      {
        actionType: IPermissionActionType.View,
        dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
      }
    )
      ? [
          {
            label: "Expense Register",
            key: "25",
            children: (
              <>
                <RegisterDetail voucherType={25} />
              </>
            ),
          },
        ]
      : []),

    ...(findUserPremission(
      ["Voucher.Income.View"],
      clientSpecificRole(),
      currentClient?.id!,
      [SettingsSections.Income],
      {
        actionType: IPermissionActionType.View,
        dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
      }
    )
      ? [
          {
            label: "Income Register",
            key: "26",
            children: (
              <>
                <RegisterDetail voucherType={26} />
              </>
            ),
          },
        ]
      : []),

    ...(findUserPremission(
      ["Voucher.Journal.View"],
      clientSpecificRole(),
      currentClient?.id!,
      [SettingsSections.Journal],
      {
        actionType: IPermissionActionType.View,
        dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
      }
    )
      ? [
          {
            label: "Journal Register",
            key: "10",
            children: (
              <>
                <RegisterDetail voucherType={10} />
              </>
            ),
          },
        ]
      : []),
  ];

  return (
    <Card
      size="small"
      className="TableCard"
      style={{
        marginTop: "6px",
        boxShadow: "0px 0px 10px 0px #96A1C84D",
      }}
    >
      <Row justify={"end"}></Row>
      <Tabs
        activeKey={activeTabKey}
        onTabClick={(selKey: string) => setActiveTabKey(selKey)}
        type="card"
        items={items}
      ></Tabs>
    </Card>
  );
};
